export default __webpack_public_path__ + "static/media/caffeCapuccino.5bf64101.png";